import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DirectiveProviderFactory } from './directives/directives.providerFactory';
import { ResolverProviderFactory } from './resolvers/resolvers.providerFactory';
import { ServicesProviderFactory } from './services/ServicesProviderFactory';
import { LogicProviderFactory } from './logic/logic.providerFactory';
import { RepoProviderFactory } from './repository/repo.providerFactory';
import { AuthInterceptor } from './interceptors/auth.interceptor';

export class SharedProviderFactory {

	static marshallProviders(useTest = false): any[] {

		const dependencies: any[] = [
			{ provide: 'window', useValue: window },
			{ provide: 'location', useValue: location }
		];

		const directivesFactory: DirectiveProviderFactory = new DirectiveProviderFactory();
		directivesFactory.addProviderTypes(dependencies);

		const resolverFactory: ResolverProviderFactory = new ResolverProviderFactory();
		resolverFactory.addProviderTypes(dependencies);

		const servicesFactory: ServicesProviderFactory = new ServicesProviderFactory();
		servicesFactory.addProviderTypes(dependencies);

		const repoFactory: RepoProviderFactory = new RepoProviderFactory();
		repoFactory.addProviderTypes(dependencies, useTest);

		const logicProviderFactory: LogicProviderFactory = new LogicProviderFactory();
		logicProviderFactory.addProviderTypes(dependencies);

		dependencies.push({
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true,
		});

		return dependencies;
	}
}
